<template>
  <div class="component-wrapper">
    <div class="grid-container">
      <div v-for="(item, index) in items" :key="index" class="grid-item-5-2">
        <a :href="item.url" target="_blank">
          <div class="inner-grid-item ">
            <div :style="{ backgroundImage: `url(${item.imageUrl})` }" class="image-thumbnail ">
              <div class="gradient-inside d-flex align-items-end">
                <div class="hover-overlay"></div>
                <div class="title">
                  {{ item.title }}
                </div>
              </div>

            </div>
          </div>
        </a>

      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'StaticThumbnailsGrid5Desktop2Mobile',
  components: {},
  props: {
    items: {
      type: Array,
    },
  },
};
</script>

<style lang="scss" scoped>

.grid-container {
  display: flex;
  flex-wrap: wrap;

  .grid-item-5-2 {
    flex: 1 0 50%; /* proportion of the available space */
    max-width: 50%;
  }

  .inner-grid-item {
    margin: $spacing-1;
    overflow: hidden;
    border-radius: 20px;

  }
}


.component-wrapper {


  .image-thumbnail {
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    width: 100%;
    height: 250px;


  }

  .gradient-inside {
    position: relative;
    background: linear-gradient(180deg, rgba(221, 209, 203, 0.2) 0%, rgba(206, 169, 151, 0.7) 100%);
    overflow: hidden;
    width: 100%;
    height: 100%;
    color: white;
    padding: 20px;

    .title {
      z-index: 1111;
    }

    .hover-overlay {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: linear-gradient(180deg, rgba(221, 209, 203, 0.2) 0%, rgba(206, 169, 151, 1) 100%);
      opacity: 0;
      transition: opacity 0.5s ease-in-out;
    }

    &:hover .hover-overlay {
      opacity: 1;
    }
  }


}

@media screen and (min-width: 768px) {
  .grid-container {
    .grid-item-5-2 {
      flex: 1 0 20%; /* proportion of the available space */
      max-width: 20%;
    }
  }

  .component-wrapper {

    .image-thumbnail {
      height: 390px;

    }

    .title {
      font-size: $title-h4;
      line-height: 1;
    }
  }

}
</style>
